import React from 'react';
import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
// import { Socket, Presence } from 'phoenix';

// import { checkLogin, performLogin } from '../../store/actions/auth';

// import Chat from '../../components/Chat/Chat';
import css from './ClickerGame.module.scss';

class ClickerGame extends React.Component {
  constructor(props) {
    super(props);

    const sequence = []
    while(sequence.length < 20) {
      sequence.push({
        id: `arrow_${sequence.length}`,
        val: Math.round(Math.random() * 3)
      });
    }

    this.performClick = this.performClick.bind(this);

    this.state = {
      current: 0,
      done: false,
      misinput: false,
      sequence,
    };
  }

  componentDidMount() {
    const { setStartGameCallback } = this.props;
    setStartGameCallback(() => console.log('worked!'))
  }

  componentDidUpdate() {
    const { toggleReady } = this.props;
    const { current, done, sequence } = this.state;

    if (!done && (current > sequence.length - 1)) {
      console.log('done!!!');
      toggleReady();
      this.setState({
        done: true,
      })
    }
  }

  performClick(e) {
    const { current, done, misinput, sequence } = this.state;
    if (!misinput && !done) {
      if (e.key === 'ArrowLeft' && sequence[sequence.length - current - 1].val === 1) {
        this.setState({
          current: current + 1
        });
      } else if (e.key === 'ArrowRight' && sequence[sequence.length - current - 1].val === 0) {
        this.setState({
          current: current + 1
        });
      } else if (e.key === 'ArrowUp' && sequence[sequence.length - current - 1].val === 2) {
        this.setState({
          current: current + 1
        });
      } else if (e.key === 'ArrowDown' && sequence[sequence.length - current - 1].val === 3) {
        this.setState({
          current: current + 1
        });
      } else {
        console.log('misinput!!!');
        this.setState({
          misinput: true
        })
        setTimeout(() => this.setState({ misinput: false }), 500);

        // we can have simple games that are speed based (i.e. only need to send a complete event
        // once they are done OR score based -> calculate and wait OR USE PRESENCE
        // on BE we can compare
        // from the BE we need a standard format to standardize random string
        // note: spawn(fn -> :timer.sleep(1000); notify_others() end) can be used to delay in
        // BE and NOT block the current thread
      }
    }
  }

  render() {
    const { current, misinput, sequence } = this.state;
    return (
      <div className={css.gameContainer} onKeyDown={this.performClick} tabIndex="0">
        <div className={css.overlay}>
          Be the first to input the sequence!<br/>
          The game is starts in: 
        </div>
        {/* translate the fixed height */}
        <div className={css.inputContainer}>
          <div className={css.inputWrapper}>
            <div className={css.inputQueue} style={{transform: `translateY(${current * 19}px)`}}>
              {
                sequence.map((val, i) => (
                  <div className={sequence.length - current - 1 === i ? (misinput ? css.misinput : css.current) : '' } key={val.id}>
                    { val.val === 3 ? '↓' : val.val === 2 ? '↑' : val.val === 1 ?  '←' : '→'}
                  </div>
                ))
              }
            </div>
            <div className={css.currentLine}></div>
          </div>
        </div>
      </div>
    );
  }
}

ClickerGame.propTypes = {
  toggleReady: PropTypes.func.isRequired,
  setStartGameCallback: PropTypes.func.isRequired,
}

export default ClickerGame;